const LineItemTypeEnum=
{
    Addition:'Addition',
    Deduction:'Deduction',
};

export default LineItemTypeEnum;